module.exports = __webpack_public_path__ + "img/laboratorio2_4-3.2135c099.jpg";